export * from './Font';
export { useFonts } from './FontHooks';
//# sourceMappingURL=index.js.map